import { render, staticRenderFns } from "./newproductProcess.vue?vue&type=template&id=c0bf73ce&scoped=true&"
import script from "./newproductProcess.vue?vue&type=script&lang=js&"
export * from "./newproductProcess.vue?vue&type=script&lang=js&"
import style0 from "./newproductProcess.vue?vue&type=style&index=0&id=c0bf73ce&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0bf73ce",
  null
  
)

export default component.exports